import React, { forwardRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { MenuItem, TextField, withStyles } from "@material-ui/core";
import { isEmail, isQsafePrefix } from "../../../utils/helpers";
import t from "../../../languages/pl";
import { getLogin } from "../../../config/sessionData";
import { compose } from 'recompose';
import { KeyboardDatePicker } from "@material-ui/pickers";
import moment from "moment";

const useStyles = theme => ({
  row: {
    display: "flex",
    justifyContent: "flex-start",
    flexWrap: "wrap",
    marginBottom: "2.5rem"
  },
  typeSelectionRow: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "top",
    width: "100%",
    marginBottom: "1.5rem"
  },
  inputField: {
    margin: theme.spacing(1),
    minWidth: 250,
    width: 250,
  }
});

const initialState = {
  email: "",
  username: getLogin() + '.',
  name: "",
  typ: "podrzedny"
};

const UserEditableFields = forwardRef((props, ref) => {
      const {
        classes,
        onChange,
        email,
        name,
        username,
        onSubmit,
        login,
        typ,
        pracuje_od,
        pracuje_do,
        onTypeChange
      } = props;
      const [badEmail, setBadEmail] = useState(null);
      const [badUserName, setBadUserNAme] = useState(null);
      const [state, setState] = useState(initialState);
      const [employedSince, setEmployedSince] = useState(moment());
      const [employedTo, setEmployedTo] = useState(moment().add(1, "day"));

      useEffect(() => {
        setState({
          email: email ? email : initialState.email,
          username: username ? username : login + '.',
          name: name ? name : initialState.name,
          typ: typ ? typ : initialState.typ
        });

        setEmployedSince(moment(pracuje_od));
        setEmployedTo(moment(pracuje_do));
      }, [email, username, name, typ, pracuje_od, pracuje_do]);

      useEffect(() => {
        onChange && onChange(state);
      }, [state]);

      const validateEmail = e => {
        if (!isEmail(e.target.value))
          setBadEmail(t.incorrectEmailFormat);
        else setBadEmail(null);
      };

      const validateUserName = e => {
        if (!e.target.value)
          setBadUserNAme(t.incorrectUserName);
        else setBadUserNAme(null);
      };

      const handleEmployedSince = date => {
        setEmployedSince(date);
        setState({ ...state, pracuje_od: date.format() });
      };

      const handleEmployedTo = date => {
        setEmployedTo(date);
        setState({ ...state, pracuje_do: date.format() });
      };

      const handleEmailChange = e => {
        if (badEmail !== null && isEmail(e.target.value))
          setBadEmail(null);
        setState({ ...state, email: e.currentTarget.value });
      };

      const handleUsernameChange = e => {
        if (isQsafePrefix(getLogin(), e.target.value)) {
          setState({
            ...state,
            username: e.target.value
          });
        } else if (e.target.value === "")
          setState({ ...state, username: initialState.username });
      };

      const handleChange = e => {
        setState({
          ...state,
          [e.target.name]: e.target.value
        });

        if (e.target.name === "typ" && onTypeChange) {
          onTypeChange(e.target.value);
          if (e.target.value === "tymczasowy") {
            setState({
              ...state,
              typ: e.target.value,
              pracuje_od: moment().format(),
              pracuje_do: moment().add(1, "day").format()
            });
          } else {
            setState({
              ...state,
              typ: e.target.value,
              pracuje_od: "",
              pracuje_do: ""
            });
          }
        }
      };

      return (
        <React.Fragment>
          <form ref={ref} className={classes.row} onSubmit={() => onSubmit(state)}>
            <div className={classes.typeSelectionRow}>
              <TextField
                label={t.userAccountType}
                className={classes.inputField}
                select
                name="typ"
                value={state.typ}
                onChange={handleChange}
              >
                <MenuItem value={'podadmin'}>{t.subAdmin}</MenuItem>
                <MenuItem value={'podrzedny'}>{t.subUser}</MenuItem>
                <MenuItem value={'tymczasowy'}>{t.temporaryUser}</MenuItem>
              </TextField>

              {state.typ === 'tymczasowy' ? <div>
                <KeyboardDatePicker
                  label={t.inPeriodFrom}
                  className={classes.inputField}
                  format="DD-MM-YYYY"
                  invalidDateMessage={t.invalidDate}
                  value={employedSince}
                  onChange={handleEmployedSince}
                />
                <KeyboardDatePicker
                  label={t.inPeriodTo}
                  className={classes.inputField}
                  format="DD-MM-YYYY"
                  invalidDateMessage={t.invalidDate}
                  value={employedTo}
                  minDate={employedSince}
                  onChange={handleEmployedTo}
                />
              </div> : null}
            </div>

            <TextField
              label={t.emailAddressLabel}
              className={classes.inputField}
              error={badEmail !== null}
              helperText={badEmail}
              type="email"
              name="email"
              value={state.email}
              onChange={handleEmailChange}
              onBlur={validateEmail}
            />
            <TextField
              label={t.username}
              className={classes.inputField}
              name="username"
              value={state.username}
              onChange={handleUsernameChange}
              onBlur={handleChange}
            />
            <TextField
              label={t.firstAndLastName}
              className={classes.inputField}
              type="text"
              name="name"
              value={state.name}
              error={badUserName !== null}
              helperText={badUserName}
              onChange={handleChange}
              onBlur={validateUserName}
            />

            {props.children}
          </form>
        </React.Fragment>
      );
    }
  )
;

const mapStateToProps = state => ({
  login: state.authReducer.login
});

UserEditableFields.propTypes = {
  classes: PropTypes.object,
  onChange: PropTypes.func,
  email: PropTypes.string,
  username: PropTypes.string,
  name: PropTypes.string,
  typ: PropTypes.string,
  employedSince: PropTypes.string,
  employedTo: PropTypes.string,
  children: PropTypes.node,
  onSubmit: PropTypes.func,
  //login
  login: PropTypes.string,
  onTypeChange: PropTypes.func,
  pracuje_od: PropTypes.string,
  pracuje_do: PropTypes.string
};

UserEditableFields.defaultProps = {
  email: "",
  firstName: "",
  lastName: "",
  typ: "podrzedny",
  employedSince: "",
  employedTo: "",
};

UserEditableFields.displayName = "UserEditableFields";

export default compose(
  withStyles(useStyles),
  connect(
    mapStateToProps,
    null,
    null,
    { forwardRef: true }
  )
)(UserEditableFields);
